import {Toast} from 'native-base';
import {colorSwatches} from '../styles';
import { StyleSheet, Dimensions } from 'react-native';
import sanitizeUserMessage from '../utils/sanitizeUserMessage';

const deviceWidth = Dimensions.get('window').width;

export const showErrorMessage = (description: string) => {
  const message = sanitizeUserMessage(description);
  Toast.show({
    title: message,
    variant: 'solid',
    style: flashStyles.flashMessage,
    backgroundColor: colorSwatches.red[400],
    fontSize: 14,
    placement: 'bottom',
    avoidKeyboard: true,
  });
};

export const showSuccessMessage = (description: string) => {
  const message = sanitizeUserMessage(description);
  Toast.show({
    title: message,
    backgroundColor: '#3AA76D',
    avoidKeyboard: true,
    style: flashStyles.flashMessage,
    placement: 'bottom',
  });
};

export const showInformationMessage = (description: string) => {
  const message = sanitizeUserMessage(description);
  Toast.show({
    title: message,
    avoidKeyboard: true,
    style: flashStyles.flashMessage
  });
};

export const showMessageWithCopy = (description: string) => {
  const message = sanitizeUserMessage(description);
  Toast.show({
    title: message,
    avoidKeyboard: true,
    style: flashStyles.flashMessage
  });
};

export const showPermissionMessage = () => {
  Toast.show({
    title: 'No permission to perform this operation',
    avoidKeyboard: true,
    style: flashStyles.flashMessage
  });
};

const flashStyles = StyleSheet.create({
  flashMessage: {
    bottom: 60,
  },
})
